import { POST } from '../../apiController';

const ADMIN = '/admin/deleted-accounts';

export const listDeletedAccounts = (data) => POST(`${ADMIN}/list`, data);

export const restoreDeletedAccount = (data) => POST(`${ADMIN}/restore`, data);

export const permanentDeleteAccount = (data) => POST(`${ADMIN}/permanent-delete`, data);
